export default __webpack_public_path__ + "static/media/3_1_2.1dfff402.png";